import React from 'react';
import { Box, Card } from '@mui/material';
import { Check, Lock } from '@mui/icons-material';
import { makeStyles } from "tss-react/mui";
import { height } from '@mui/system';


const useStyles = makeStyles()((theme) => ({
    card: {
        position: 'relative',
        padding: '1rem',
        borderRadius: '10px',
        marginBottom: '1rem'
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    completedIconContainer: {
        position: 'absolute',
        bottom: 10,
        right: 10,
    },
    completedIcon: {
        height: '60px',
        width: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.LIGHT_GREEN,
        borderRadius: '50%'
    },
    iconContainer: {
        height: '100px',
        width: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50px'
    },
    icon: {
        color: colors.GREEN,
        fontSize: '3rem',
    },
    lockIcon: {
        color: '#fff',
        fontSize: '3rem'
    },
    content: {
        pointerEvents: 'none',
    },
}));

const colors = {
    RED: 'var(--mui-palette-primary-red)',
    LIGHT_RED: 'var(--mui-palette-gray-lightGrey200)',
    GREEN: 'var(--mui-palette-primary-green)',
    LIGHT_GREEN: 'var(--mui-palette-darkGrey-darkGrey50)',
}

export const SectionCard = ({ children, disabled, completed, style }) => {
    const { classes } = useStyles();

    return (
        // <Box className={classes.card} style={{ ...(completed ? { border: '2px solid ' + colors.GREEN } : {}), ...style }}>
        //     {disabled ?
        //         <div className={classes.overlay}>
        //             <div className={classes.iconContainer} style={!completed ? { backgroundColor: 'grey' } : {}}>
        //                 {!completed && <Lock className={classes.lockIcon} />}
        //             </div>
        //         </div>
        //         :
        //         (completed && <div className={classes.completedIconContainer}>
        //             <div className={classes.completedIcon}>
        //                 <Check className={classes.icon} style={{ fontSize: '2rem' }} />
        //             </div>
        //         </div>)
        //     }
        //     {children}
        // </Box>
        <Box {...{ style }} sx={{ ...style }} >
            {/* {disabled ?
                <div className={classes.overlay}>
                    <div className={classes.iconContainer} style={!completed ? { backgroundColor: 'grey' } : {}}>
                        {!completed && <Lock className={classes.lockIcon} />}
                    </div>
                </div>
                :
                (completed && <div className={classes.completedIconContainer}>
                    <div className={classes.completedIcon}>
                        <Check className={classes.icon} style={{ fontSize: '2rem' }} />
                    </div>
                </div>)
            } */}
            {children}
        </Box>
    );
};